/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TopRouteImport } from './routes/top'
import { Route as SearchRouteImport } from './routes/search'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as DuplicatesRouteImport } from './routes/duplicates'
import { Route as CreateRouteImport } from './routes/create'
import { Route as ContributorsRouteImport } from './routes/contributors'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as BlueprintsRouteImport } from './routes/blueprints'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FavoritesIndexRouteImport } from './routes/favorites.index'
import { Route as ViewBlueprintIdRouteImport } from './routes/view.$blueprintId'
import { Route as UserUserIdRouteImport } from './routes/user.$userId'
import { Route as TagTagRouteImport } from './routes/tag.$tag'
import { Route as ImportFactorioBinRouteImport } from './routes/import.factorio-bin'
import { Route as FavoritesUserIdRouteImport } from './routes/favorites.$userId'
import { Route as EditBlueprintIdRouteImport } from './routes/edit.$blueprintId'
import { Route as AuthEmailCallbackRouteImport } from './routes/auth.email-callback'
import { Route as TaggedCategoryNameRouteImport } from './routes/tagged.$category.$name'
import { Route as AdminUserUserIdRouteImport } from './routes/admin.user.$userId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TopRoute = TopRouteImport.update({
  id: '/top',
  path: '/top',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesRoute = FavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const DuplicatesRoute = DuplicatesRouteImport.update({
  id: '/duplicates',
  path: '/duplicates',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateRoute = CreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ContributorsRoute = ContributorsRouteImport.update({
  id: '/contributors',
  path: '/contributors',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const BlueprintsRoute = BlueprintsRouteImport.update({
  id: '/blueprints',
  path: '/blueprints',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesIndexRoute = FavoritesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FavoritesRoute,
} as any)
const ViewBlueprintIdRoute = ViewBlueprintIdRouteImport.update({
  id: '/view/$blueprintId',
  path: '/view/$blueprintId',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdRoute = UserUserIdRouteImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const TagTagRoute = TagTagRouteImport.update({
  id: '/tag/$tag',
  path: '/tag/$tag',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportFactorioBinRoute = ImportFactorioBinRouteImport.update({
  id: '/import/factorio-bin',
  path: '/import/factorio-bin',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesUserIdRoute = FavoritesUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => FavoritesRoute,
} as any)
const EditBlueprintIdRoute = EditBlueprintIdRouteImport.update({
  id: '/edit/$blueprintId',
  path: '/edit/$blueprintId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthEmailCallbackRoute = AuthEmailCallbackRouteImport.update({
  id: '/auth/email-callback',
  path: '/auth/email-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const TaggedCategoryNameRoute = TaggedCategoryNameRouteImport.update({
  id: '/tagged/$category/$name',
  path: '/tagged/$category/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUserUserIdRoute = AdminUserUserIdRouteImport.update({
  id: '/admin/user/$userId',
  path: '/admin/user/$userId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/blueprints': typeof BlueprintsRoute
  '/chat': typeof ChatRoute
  '/contributors': typeof ContributorsRoute
  '/create': typeof CreateRoute
  '/duplicates': typeof DuplicatesRoute
  '/favorites': typeof FavoritesRouteWithChildren
  '/search': typeof SearchRoute
  '/top': typeof TopRoute
  '/users': typeof UsersRoute
  '/auth/email-callback': typeof AuthEmailCallbackRoute
  '/edit/$blueprintId': typeof EditBlueprintIdRoute
  '/favorites/$userId': typeof FavoritesUserIdRoute
  '/import/factorio-bin': typeof ImportFactorioBinRoute
  '/tag/$tag': typeof TagTagRoute
  '/user/$userId': typeof UserUserIdRoute
  '/view/$blueprintId': typeof ViewBlueprintIdRoute
  '/favorites/': typeof FavoritesIndexRoute
  '/admin/user/$userId': typeof AdminUserUserIdRoute
  '/tagged/$category/$name': typeof TaggedCategoryNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/blueprints': typeof BlueprintsRoute
  '/chat': typeof ChatRoute
  '/contributors': typeof ContributorsRoute
  '/create': typeof CreateRoute
  '/duplicates': typeof DuplicatesRoute
  '/search': typeof SearchRoute
  '/top': typeof TopRoute
  '/users': typeof UsersRoute
  '/auth/email-callback': typeof AuthEmailCallbackRoute
  '/edit/$blueprintId': typeof EditBlueprintIdRoute
  '/favorites/$userId': typeof FavoritesUserIdRoute
  '/import/factorio-bin': typeof ImportFactorioBinRoute
  '/tag/$tag': typeof TagTagRoute
  '/user/$userId': typeof UserUserIdRoute
  '/view/$blueprintId': typeof ViewBlueprintIdRoute
  '/favorites': typeof FavoritesIndexRoute
  '/admin/user/$userId': typeof AdminUserUserIdRoute
  '/tagged/$category/$name': typeof TaggedCategoryNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/blueprints': typeof BlueprintsRoute
  '/chat': typeof ChatRoute
  '/contributors': typeof ContributorsRoute
  '/create': typeof CreateRoute
  '/duplicates': typeof DuplicatesRoute
  '/favorites': typeof FavoritesRouteWithChildren
  '/search': typeof SearchRoute
  '/top': typeof TopRoute
  '/users': typeof UsersRoute
  '/auth/email-callback': typeof AuthEmailCallbackRoute
  '/edit/$blueprintId': typeof EditBlueprintIdRoute
  '/favorites/$userId': typeof FavoritesUserIdRoute
  '/import/factorio-bin': typeof ImportFactorioBinRoute
  '/tag/$tag': typeof TagTagRoute
  '/user/$userId': typeof UserUserIdRoute
  '/view/$blueprintId': typeof ViewBlueprintIdRoute
  '/favorites/': typeof FavoritesIndexRoute
  '/admin/user/$userId': typeof AdminUserUserIdRoute
  '/tagged/$category/$name': typeof TaggedCategoryNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/blueprints'
    | '/chat'
    | '/contributors'
    | '/create'
    | '/duplicates'
    | '/favorites'
    | '/search'
    | '/top'
    | '/users'
    | '/auth/email-callback'
    | '/edit/$blueprintId'
    | '/favorites/$userId'
    | '/import/factorio-bin'
    | '/tag/$tag'
    | '/user/$userId'
    | '/view/$blueprintId'
    | '/favorites/'
    | '/admin/user/$userId'
    | '/tagged/$category/$name'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/blueprints'
    | '/chat'
    | '/contributors'
    | '/create'
    | '/duplicates'
    | '/search'
    | '/top'
    | '/users'
    | '/auth/email-callback'
    | '/edit/$blueprintId'
    | '/favorites/$userId'
    | '/import/factorio-bin'
    | '/tag/$tag'
    | '/user/$userId'
    | '/view/$blueprintId'
    | '/favorites'
    | '/admin/user/$userId'
    | '/tagged/$category/$name'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/blueprints'
    | '/chat'
    | '/contributors'
    | '/create'
    | '/duplicates'
    | '/favorites'
    | '/search'
    | '/top'
    | '/users'
    | '/auth/email-callback'
    | '/edit/$blueprintId'
    | '/favorites/$userId'
    | '/import/factorio-bin'
    | '/tag/$tag'
    | '/user/$userId'
    | '/view/$blueprintId'
    | '/favorites/'
    | '/admin/user/$userId'
    | '/tagged/$category/$name'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  BlueprintsRoute: typeof BlueprintsRoute
  ChatRoute: typeof ChatRoute
  ContributorsRoute: typeof ContributorsRoute
  CreateRoute: typeof CreateRoute
  DuplicatesRoute: typeof DuplicatesRoute
  FavoritesRoute: typeof FavoritesRouteWithChildren
  SearchRoute: typeof SearchRoute
  TopRoute: typeof TopRoute
  UsersRoute: typeof UsersRoute
  AuthEmailCallbackRoute: typeof AuthEmailCallbackRoute
  EditBlueprintIdRoute: typeof EditBlueprintIdRoute
  ImportFactorioBinRoute: typeof ImportFactorioBinRoute
  TagTagRoute: typeof TagTagRoute
  UserUserIdRoute: typeof UserUserIdRoute
  ViewBlueprintIdRoute: typeof ViewBlueprintIdRoute
  AdminUserUserIdRoute: typeof AdminUserUserIdRoute
  TaggedCategoryNameRoute: typeof TaggedCategoryNameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/top': {
      id: '/top'
      path: '/top'
      fullPath: '/top'
      preLoaderRoute: typeof TopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites': {
      id: '/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof FavoritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/duplicates': {
      id: '/duplicates'
      path: '/duplicates'
      fullPath: '/duplicates'
      preLoaderRoute: typeof DuplicatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create': {
      id: '/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contributors': {
      id: '/contributors'
      path: '/contributors'
      fullPath: '/contributors'
      preLoaderRoute: typeof ContributorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blueprints': {
      id: '/blueprints'
      path: '/blueprints'
      fullPath: '/blueprints'
      preLoaderRoute: typeof BlueprintsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites/': {
      id: '/favorites/'
      path: '/'
      fullPath: '/favorites/'
      preLoaderRoute: typeof FavoritesIndexRouteImport
      parentRoute: typeof FavoritesRoute
    }
    '/view/$blueprintId': {
      id: '/view/$blueprintId'
      path: '/view/$blueprintId'
      fullPath: '/view/$blueprintId'
      preLoaderRoute: typeof ViewBlueprintIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$userId': {
      id: '/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof UserUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tag/$tag': {
      id: '/tag/$tag'
      path: '/tag/$tag'
      fullPath: '/tag/$tag'
      preLoaderRoute: typeof TagTagRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/factorio-bin': {
      id: '/import/factorio-bin'
      path: '/import/factorio-bin'
      fullPath: '/import/factorio-bin'
      preLoaderRoute: typeof ImportFactorioBinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites/$userId': {
      id: '/favorites/$userId'
      path: '/$userId'
      fullPath: '/favorites/$userId'
      preLoaderRoute: typeof FavoritesUserIdRouteImport
      parentRoute: typeof FavoritesRoute
    }
    '/edit/$blueprintId': {
      id: '/edit/$blueprintId'
      path: '/edit/$blueprintId'
      fullPath: '/edit/$blueprintId'
      preLoaderRoute: typeof EditBlueprintIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/email-callback': {
      id: '/auth/email-callback'
      path: '/auth/email-callback'
      fullPath: '/auth/email-callback'
      preLoaderRoute: typeof AuthEmailCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tagged/$category/$name': {
      id: '/tagged/$category/$name'
      path: '/tagged/$category/$name'
      fullPath: '/tagged/$category/$name'
      preLoaderRoute: typeof TaggedCategoryNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/user/$userId': {
      id: '/admin/user/$userId'
      path: '/admin/user/$userId'
      fullPath: '/admin/user/$userId'
      preLoaderRoute: typeof AdminUserUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface FavoritesRouteChildren {
  FavoritesUserIdRoute: typeof FavoritesUserIdRoute
  FavoritesIndexRoute: typeof FavoritesIndexRoute
}

const FavoritesRouteChildren: FavoritesRouteChildren = {
  FavoritesUserIdRoute: FavoritesUserIdRoute,
  FavoritesIndexRoute: FavoritesIndexRoute,
}

const FavoritesRouteWithChildren = FavoritesRoute._addFileChildren(
  FavoritesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  BlueprintsRoute: BlueprintsRoute,
  ChatRoute: ChatRoute,
  ContributorsRoute: ContributorsRoute,
  CreateRoute: CreateRoute,
  DuplicatesRoute: DuplicatesRoute,
  FavoritesRoute: FavoritesRouteWithChildren,
  SearchRoute: SearchRoute,
  TopRoute: TopRoute,
  UsersRoute: UsersRoute,
  AuthEmailCallbackRoute: AuthEmailCallbackRoute,
  EditBlueprintIdRoute: EditBlueprintIdRoute,
  ImportFactorioBinRoute: ImportFactorioBinRoute,
  TagTagRoute: TagTagRoute,
  UserUserIdRoute: UserUserIdRoute,
  ViewBlueprintIdRoute: ViewBlueprintIdRoute,
  AdminUserUserIdRoute: AdminUserUserIdRoute,
  TaggedCategoryNameRoute: TaggedCategoryNameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
